
import Vue from 'vue';
import store from '@/store';
import { Component } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { Action, Getter, Mutation } from 'vuex-class';
import { Funder } from '@/types/funder';
import { startCase } from 'lodash';
import FunderListTile from '@/components/Funder/FunderListTile.vue';
import ContentPreview from '@/components/Editor/ContentPreview.vue';

@Component({
  components: { ContentPreview, FunderListTile },
})
export default class FunderList extends Vue {
  @Action('funders/getFunders') getFunders!: Function;
  @Getter('funders/funders') funders!: Funder[];
  @Getter('funders/totalFunderPages') totalFunderPages!: number;
  @Getter('funders/tierFilter') tierFilter!: string | null;
  @Getter('funders/enabledFilter') enabledFilter!: boolean | null;
  @Mutation('funders/setTierFilter') setTierFilter!: Function;
  @Mutation('funders/setEnabledFilter') setEnabledFilter!: Function;

  dialog: boolean = false;
  funderId: string | null = null;
  tiers: object = [
    { 'text': 'no filter', value: null },
    { 'text': 'Tier 1', value: 'Tier 1' },
    { 'text': 'Tier 2', value: 'Tier 2' },
    { 'text': 'Tier 3', value: 'Tier 3' },
    { 'text': 'Tier 4', value: 'Tier 4' },
    { 'text': 'Tier 5', value: 'Tier 5' },
  ];
  enabledStates: object = [
    { 'text': 'no filter', value: null },
    { 'text': 'Published', value: true },
    { 'text': 'Unpublished', value: false },
  ];

  get pageName(): string {
    const name = this.$route.name || undefined;
    return startCase(name);
  }

  get currentFunderPage() {
    return this.$store.getters['funders/currentFunderPage'];
  }
  set currentFunderPage(page) {
    this.getFunders({ page });
  }

  get tier(): string | null {
    return this.tierFilter;
  }
  set tier(value: string | null) {
    this.setTierFilter(value);
    this.getFunders({ page: 1 });
  }

  get enabled(): boolean | null {
    return this.enabledFilter;
  }
  set enabled(value: boolean | null) {
    this.setEnabledFilter(value);
    this.getFunders({ page: 1 });
  }

  newPage() {
    this.$router.push('/pages/editor');
  }

  viewPage(id: string | null) {
     this.funderId = id;
     this.dialog = true;
  }

  async beforeRouteEnter(to: Route, from: Route, next: Function) {
    await store.dispatch('funders/getFunders', { page: 1 });
    next();
  }
}
